
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, CheckCircle } from "lucide-react";
import { VisaGuideData } from "@/types/visa";

interface VisaResourcesProps {
  visaData: VisaGuideData[string][string];
}

const VisaResources = ({ visaData }: VisaResourcesProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Helpful Resources</CardTitle>
        <CardDescription>Official websites and helpful links</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mb-6">
          <h3 className="font-semibold text-lg mb-4">Official Resources:</h3>
          <div className="space-y-3">
            {visaData.resources.map((resource, index) => (
              <a 
                key={index}
                href={resource.url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center p-4 border rounded-lg hover:bg-blue-50 transition-colors"
              >
                <FileText className="h-5 w-5 text-blue-600 mr-3" />
                <span>{resource.name}</span>
              </a>
            ))}
          </div>
        </div>
        
        <div>
          <h3 className="font-semibold text-lg mb-4">Travel Tips:</h3>
          <ul className="space-y-2">
            {visaData.tips.map((tip, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default VisaResources;
